import { render, staticRenderFns } from "./HotelBooking.vue?vue&type=template&id=cfa5df52&scoped=true&"
import script from "./HotelBooking.vue?vue&type=script&lang=js&"
export * from "./HotelBooking.vue?vue&type=script&lang=js&"
import style0 from "./HotelBooking.vue?vue&type=style&index=0&id=cfa5df52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa5df52",
  null
  
)

export default component.exports